import { Action } from '@ngrx/store';
// eslint-disable-next-line max-len
import { VehicleMaintenanceSchedule } from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len
import { VehicleMaintenanceScheduleQueryParameters } from '@quorum/models/xs-query';
export const GET_MAINTENANCE_SCHEDULES_FROM_SERVER = '[VEHICLE_MAINTENANCE] Get Maintenance Schedules From Server';
export class GetMaintenanceSchedulesFromServer implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_MAINTENANCE_SCHEDULES_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: VehicleMaintenanceScheduleQueryParameters) {}
}

export const GET_MAINTENANCE_SCHEDULES_FROM_SERVER_SUCCESS =
  '[VEHICLE_MAINTENANCE] Get Maintenance Schedules From Server Success';
export class GetMaintenanceSchedulesFromServerSuccess implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_MAINTENANCE_SCHEDULES_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { maintenanceSchedules: VehicleMaintenanceSchedule[] }) {}
}

export const GET_MAINTENANCE_SCHEDULES_FROM_SERVER_FAILURE =
  '[VEHICLE_MAINTENANCE] Get Maintenance Schedules From Server Failure';
export class GetMaintenanceSchedulesFromServerFailure implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_MAINTENANCE_SCHEDULES_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const CLEAR_MAINTENANCE_SCHEDULES_IN_STATE = '[VEHICLE_MAINTENANCE] Clear Maintenance Schedules In State';
export class ClearMaintenanceSchedulesInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = CLEAR_MAINTENANCE_SCHEDULES_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export type MaintenanceScheduleAction =
  | GetMaintenanceSchedulesFromServer
  | GetMaintenanceSchedulesFromServerSuccess
  | GetMaintenanceSchedulesFromServerFailure
  | ClearMaintenanceSchedulesInState;
